import {useContext, useEffect, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {NAME_SPACES} from "../../shared/locals/constants";
import {StoreContext} from "../../shared/store";
import i18n from "i18next";
import Spin from "../../shared/components/Spin";

export const PrivacyPolicyDocument = ({title = "Privacy policy"}) => {
	const {t} = useTranslation(NAME_SPACES.ACCOUNT);
	useEffect(() => {
		window.document.title = t("CONTACT.PRIVACY_POLICY_LINK_LABEL", title);
	}, [title, t]);

	const {info} = useContext(StoreContext);

	const privacyPolicyLink = useMemo(() => {
		let privacyPolicyLink = null;

		if (Array.isArray(info.privacyPolicies) && info.privacyPolicies.length > 0) {
			privacyPolicyLink = info.privacyPolicies.find(item => item.lang === i18n.language);
			if (privacyPolicyLink == null) {
				privacyPolicyLink = info.privacyPolicies.find(item => item.lang === i18n.languages[0]);
			}
			if (privacyPolicyLink == null) {
				privacyPolicyLink = info.privacyPolicies.find(item => i18n.options.supportedLngs.includes(item.lang));
			}

			if (privacyPolicyLink == null) {
				privacyPolicyLink = info.privacyPolicies[0];
			}

		}
		return privacyPolicyLink;
	}, [info.privacyPolicies]);
	return (<>
				{privacyPolicyLink != null ?
				 <iframe src={privacyPolicyLink.url.trim() + "#view=fit"} title="private policy"
				         style={{border: "none", width: "100vw", height: "100vh", display: "block", position: "absolute", top: "0", left: "0"}} /> :
				 (Object.entries(info).length === 0 ?
				  <div style={{textAlign:"center", padding:"25%", height:"100vh"}}><Spin  /> </div> :
				  <div style={{textAlign:"center", padding:"25%", height:"100vh"}}>{t("CONTACT.PRIVACY_POLICY_NOT_FOUND")}</div>)
				}
			</>
	)
}